import { render, staticRenderFns } from "./editQuestionnaire.vue?vue&type=template&id=547002bc&scoped=true&"
import script from "./editQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./editQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./editQuestionnaire.vue?vue&type=style&index=0&id=547002bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547002bc",
  null
  
)

export default component.exports